/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum Routes {
  ACCOUNT_ACTIVATION = '/activate',
  ACCOUNT_CREATION_COMPLETED = '/login/create-new-user/completed',
  ACCOUNT_CREATION_MODAL = '/login/create-new-user',
  ACCOUNT_CREATION_PROCESSING = '/login/create-new-user/processing',
  ACCOUNT_REACTIVATE = '/resend-link/:token',
  APPLICATION_VERSION = '/version',
  FORGET_PASSWORD_REQUEST_SUCCESS = '/forget-password/success',
  FORGET_PASSWORD_RESET_FAILURE = '/reset-password-failure',
  FORGET_PASSWORD_RESET_SUCCESS = '/reset-password-success',
  HOME = '/patients/dashboard',
  INACTIVITY = '/logout-inactivity',
  LOGIN = '/login',
  LOGIN_COOKIE_POLICY = '/login/cookie-policy',
  LOGIN_FORGOT_PASSWORD = '/login/forget-password',
  PRIVACY_MODAL = '/login/create-new-user/privacy-modal',
  PRIVACY_TERM = '/privacy/:nrSeqTermo',
  PUBLIC_SCHEDULE_ACTIONS = '/public/scheduling-actions/type/:type/:token',
  RESET_PASSWORD = '/reset-password',
  TERMS_OF_USE = '/terms-of-use/:nrSeqTermo/type/:termType',
  TERMS_OF_USE_MODAL = '/login/create-new-user/terms-of-use-modal',
}
export { Routes };
